<rt-icon [name]="cardType | rtCreditCardVendorIcon: 'credit-card'"></rt-icon>
&nbsp;••••&nbsp;••••&nbsp;••••&nbsp;{{ cardLast4Digits }}
<rt-divider variant="dot"></rt-divider>
{{ expiresI18NKey | translate: { date: cardExpirationDate | amDateFormat: 'MM / YYYY' } }}
